import { render, staticRenderFns } from "./CreateDataSubject.vue?vue&type=template&id=ef6b718a&"
import script from "./CreateDataSubject.vue?vue&type=script&lang=js&"
export * from "./CreateDataSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports